import useGetApi from 'src/api/useGetApi';

export interface CategoryDTO {
  id: string;
  name: string;
  description?: string | null;
  parentCategoryId?: string | null;
  metadata?: object | null;
  parentCategory?: CategoryDTO | null;
  childCategories?: CategoryDTO[];
  // products?: ProductDTO[];
  productCount?: number;
}

interface ResponseDTO {
  categories: CategoryDTO[];
}
interface QueryParams {
  parentCategoryId?: string;
}

const useCategories = (params: QueryParams, enabled?: boolean) => {
  return useGetApi<ResponseDTO>({
    endpoint: 'inventory-management/categories',
    queryParameters: params,
    options: {
      enabled,
    },
  });
};

export default useCategories;
